import StarBorderIcon from '@mui/icons-material/StarOutlineRounded'
import StarIcon from '@mui/icons-material/StarRateRounded'
import IconButton from '@mui/material/IconButton'
import React, { useCallback } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import type { PayloadAction } from '@reduxjs/toolkit'

type FavoriteUrlButtonConfig<TState> = {
  selectFavoriteUrl: (state: TState) => string
  // Loosened from PayloadActionCreator<string> since an untyped .js slice's action creator
  // doesn't carry `.type`/`.match`, and dispatch only needs the returned action shape.
  setFavoriteUrl: (url: string) => PayloadAction<string>
}

// Call at module scope so the component identity is stable — MenuGroup takes it as
// RenderSecondaryAction and would remount every row otherwise.
export const createFavoriteUrlButton = <TState,>({ selectFavoriteUrl, setFavoriteUrl }: FavoriteUrlButtonConfig<TState>) => {
  const FavoriteUrlButton = ({ url }: { url: string }) => {
    const dispatch = useDispatch()
    const favoriteUrl = useSelector(selectFavoriteUrl, shallowEqual)
    const isFavorite = url === favoriteUrl

    const handleClick = useCallback(
      (event: React.MouseEvent<HTMLButtonElement>) => {
        // The row itself is a Link; without both of these, starring also navigates.
        event.preventDefault()
        event.stopPropagation()
        dispatch(setFavoriteUrl(url))
      },
      [dispatch, url]
    )

    return <IconButton onClick={handleClick}>{isFavorite ? <StarIcon /> : <StarBorderIcon />}</IconButton>
  }

  return FavoriteUrlButton
}
